export enum WalkthroughType {
  FULL = 'FULL',
  FULL_NO_PROGRAMS = 'FULL_NO_PROGRAMS',
  SHORT = 'SHORT',
  SHORT_NO_PROGRAMS = 'SHORT_NO_PROGRAMS',
}

export interface WalkthroughConfig {
  type: WalkthroughType;
  count: number;
}

export enum JoyRideActionTypes {
  PREV = 'prev',
  NEXT = 'next',
}

export enum WalkthroughProducts {
  CKLA = 'CKLA',
  CAMINOS = 'Caminos',
  ELA = 'ELA',
  DESMOS_MATH = 'Math',
  SCIENCE = 'Science',
  ELP = 'Elementary Literacy Program',
  TEXAS_ELAR = 'Texas ELAR 6-8',
}
